import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    wrapperDialog: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    },
    containerFiledItem: {
      display: "flex",
      flexDirection: "row",
      gap: "32px",
    },
    titleItem: {
      fontSize: "14px",
      fontWeight: 600,
      color: theme.palette.text.secondary,
      lineHeight: "20px",
      maxWidth: "280px",
      minWidth: "160px",
    },
    subTitleItem: {
      fontSize: "14px",
      fontWeight: 400,
      color: theme.palette.text.tertiary,
      lineHeight: "20px",
    },
    containerTitles: {
      maxWidth: "280px",
      minWidth: "160px",
      display: "flex",
      flexDirection: "column",
    },
    containerLinkInput: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      width: "100%",
    },
    MoreLinkesContainer: {
      display: "flex",
      flexDirection: "column",
      margin: "0px 0px 16px 0px",
    },
    HeaderTableSection: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      backgroundColor: theme.palette.background.hover,
      padding: "12px 24px",
    },
    TitleItemTable: {
      fontSize: "14px",
      fontWeight: "600",
      lineHeight: "20px",
      color: theme.palette.text.tertiary,
    },
    BodyTableSection: {
      display: "flex",
      flexDirection: "column",
    },
    rowMoreLinkes: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      padding: "16px 24px",
      borderBottom: `1px solid ${theme.palette.utility.utility_gray_200}`,
    },
    uploadedSection: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      gap: "16px",
    },
    containerUpladedFilesCrads: {
      display: "flex",
      flexDirection: "column",
      gap: "12px",
    },
    CardUploadedFilesInfo: {
      display: "flex",
      flexDirection: "row",
      padding: "16px",
      gap: "12px",
    },
    ContainerFileUploadedInfo: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
    },
    containerTitleAndDeleteIcon: {
      position: "relative",
    },
    DeleteIcon: {
      cursor: "pointer",
      position: "absolute",
      right: "0px",
      top: "0px",
    },
    TitleFileName: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: "330px",
      display: "inline-block",
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "20px",
      color: theme.palette.text.secondary,
    },
    FileSizeTitle: {
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
      color: theme.palette.text.tertiary,
    },
    HyperLinkItem: {
      color: theme.palette.text.tertiary,
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
      textDecoration: "none",
      "&:hover": {
        color: theme.palette.text.tertiary,
        fontSize: "14px",
        fontWeight: "400",
        lineHeight: "20px",
      },
    },
  };
});
